import { render } from "./HomePaperCenter.vue?vue&type=template&id=6cc0084d&scoped=true"
import script from "./HomePaperCenter.vue?vue&type=script&lang=js"
export * from "./HomePaperCenter.vue?vue&type=script&lang=js"

import "./HomePaperCenter.vue?vue&type=style&index=0&id=6cc0084d&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc0084d"]])

export default __exports__